module.exports = __webpack_public_path__ + "static/img/encountera.4813693.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/encountera.png
// module id = VdWU
// module chunks = 7